import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import { apiMethod, apiType, API_URL } from 'utils';
import OrderManagementApiService from './OrderManagementApiService';
import { IPayload } from 'Model/IPayload';
import { GET_APPROVER_UPDATES_GRID_DATA, GET_COMPLIANCE_AUDIT_EXPORT_EXCEL, GET_COMPLIANCE_MODIFICATION_REPORT, GET_COMPLIANCE_REPORT_GRID_DATA, GET_COMPLIANCE_REPORT_TABLE_EXCEL } from 'Store/OrderManagement/ComplainceReport/ComplainceReportType';
import { setApproverUpdatesGridData, setComplianceModificationReport, setComplianceReportGridData, setComplianceReportTableExcel, setcomplianceAuditExportExcel } from 'Store/OrderManagement/ComplainceReport/ComplainceReportAction';
import { setIsMyOrdersGridLoading } from 'Store/Transfer/TransferGrid/TransferGridAction';

function* getComplianceReportGridDataSaga(req?: any): any {
    yield put(setIsMyOrdersGridLoading(true))
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.OrderManagement,
        endpoint: `compliancereport`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Fetching grid details...."));

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            yield put(setIsMyOrdersGridLoading(false))
            yield put(setComplianceReportGridData(response));
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setComplianceReportGridData(null))
        yield put(globalLoaderText(""));
    }
}

function* getComplianceReportTableExcelSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.OrderManagement,
        endpoint: `compliancereport/excel`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Exporting values...."));
        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        if (response) {
            yield put(setComplianceReportTableExcel(response));
        }
        yield put(globalLoaderText(""));

    } catch (error) {
        yield put(setComplianceReportTableExcel(null))
        yield put(globalLoaderText(""));
    }
}

function* getComplianceModificationReportDataSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.OrderManagement,
        endpoint: `hierarchy/approval/compliancereport/${req?.payload?.entityId}/${req?.payload?.entityType}?modifiedOn=${req?.payload?.modifiedOn}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching grid details...."));
        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        if (response) {
            yield put(setComplianceModificationReport(response));
        }
        yield put(globalLoaderText(""));

    } catch (error) {
        yield put(setComplianceModificationReport(null))
        yield put(globalLoaderText(""));
    }
}

function* getApproverUpdateDataSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.OrderManagement,
        endpoint: `compliancereport/approver/detail/${req?.payload?.entityId}?modifiedOn=${req?.payload?.modifiedOn}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching grid details...."));
        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        if (response) {
            yield put(setApproverUpdatesGridData(response));
        }
        yield put(globalLoaderText(""));

    } catch (error) {
        yield put(setApproverUpdatesGridData(null))
        yield put(globalLoaderText(""));
    }
}

function* getComplianceAuditExportExcelSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.OrderManagement,
        endpoint: `compliancereport/detail/excel?entityId=${req?.payload?.id}&modifiedOn=${req.payload.modifiedOn}&entityType=${req?.payload?.type}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Exporting values...."));
        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        if (response) {
            yield put(setcomplianceAuditExportExcel(response));
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setcomplianceAuditExportExcel(null))
        yield put(globalLoaderText(""));
    }
}

function* watchApprovalHierarchy() {
    yield takeEvery(GET_COMPLIANCE_REPORT_GRID_DATA, getComplianceReportGridDataSaga);
    yield takeEvery(GET_COMPLIANCE_REPORT_TABLE_EXCEL, getComplianceReportTableExcelSaga);
    yield takeEvery(GET_COMPLIANCE_MODIFICATION_REPORT, getComplianceModificationReportDataSaga);
    yield takeEvery(GET_APPROVER_UPDATES_GRID_DATA, getApproverUpdateDataSaga);
    yield takeEvery(GET_COMPLIANCE_AUDIT_EXPORT_EXCEL, getComplianceAuditExportExcelSaga);
}

export default function* combinedSaga() {
    yield all([
        watchApprovalHierarchy()
    ])
}
